import { render, staticRenderFns } from "./wareHouseSet.vue?vue&type=template&id=bff35a9c&scoped=true&"
import script from "./wareHouseSet.vue?vue&type=script&lang=js&"
export * from "./wareHouseSet.vue?vue&type=script&lang=js&"
import style0 from "./wareHouseSet.vue?vue&type=style&index=0&id=bff35a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff35a9c",
  null
  
)

export default component.exports